import type { UpdatePlatform } from '../api/appUpdate';

export const UPDATE_REMINDER_MS = 24 * 60 * 60 * 1000;
export const UPDATE_NOTIFICATIONS_KEY = 'hc_update_notifications';
export const updateNoticeKey = (platform: UpdatePlatform) => 'hc_update_notice:' + platform;
export interface UpdateNotice { version: string; at: number }

export function compareUpdateVersions(a: string, b: string): number {
  const left = a.split('.').map(Number);
  const right = b.split('.').map(Number);
  for (let i = 0; i < Math.max(left.length, right.length); i++) {
    const difference = (left[i] ?? 0) - (right[i] ?? 0);
    if (difference) return Math.sign(difference);
  }
  return 0;
}

export function validUpdateVersion(version: string): boolean {
  return /^[0-9]+(\.[0-9]+)*$/.test(version) && version.split('.').every(part => Number(part) <= 2147483647);
}

export function shouldNotifyUpdate(version: string, last: UpdateNotice | null, now: number, enabled: boolean): boolean {
  if (!enabled || !validUpdateVersion(version)) return false;
  if (!last) return true;
  const compared = compareUpdateVersions(version, last.version);
  return compared > 0 || (compared === 0 && now - last.at >= UPDATE_REMINDER_MS);
}

export function updateNotificationsEnabled(): boolean {
  try { return localStorage.getItem(UPDATE_NOTIFICATIONS_KEY) !== '0'; }
  catch { return true; }
}

export function readUpdateNotice(platform: UpdatePlatform): UpdateNotice | null {
  try {
    const value = JSON.parse(localStorage.getItem(updateNoticeKey(platform)) ?? 'null');
    return value && typeof value.version === 'string' && validUpdateVersion(value.version) &&
      Number.isFinite(value.at) && value.at >= 0 ? value : null;
  } catch { return null; }
}
